import React from 'react';

const ActionsBar: React.FC<{
  onClose: () => void;
  onSubmit: () => void;
}> = ({ onClose, onSubmit }) => {
  return (
    <div className='mt-6 flex justify-end gap-3'>
      <button
        type='button'
        className='px-4 py-2 bg-gray-100 text-slate-700 rounded-md hover:bg-gray-200'
        onClick={onClose}
        aria-label='Close modal'
      >
        Close
      </button>
      <button
        type='submit'
        className='px-4 py-2 bg-gray-100 text-slate-700 rounded-md hover:bg-gray-200'
        onClick={onSubmit}
        aria-label='Apply updates'
      >
        Update
      </button>
    </div>
  );
};

export default React.memo(ActionsBar);
